import { toNumber } from './strings/toNumber';

const CURRENCY_PARTS_LENGTH = 2;
const CENTS_START_INDEX = -2;
const ONE_HUNDRED = 100;
const ROUND_UP_THRESHOLD = 5;

export type ICurrency = number;

const formatDollars = (dollars: string, cents: string): string => `$${dollars}.${cents}`;
const formatWithoutCurrency = (dollars: string, cents: string): string => `${dollars}.${cents}`;

// This should be something like "24.99". If you have a float you need to get rid of it
export const dollarsToCents = (dollars: string): ICurrency => {
  const parts = dollars.split('.');
  if (parts.length !== CURRENCY_PARTS_LENGTH) {
    throw new Error('You need to use the format "111.11" for currencies.');
  }
  return toNumber(parts.join('')) || 0;
};
export const centsToDollars = (cents: number, currencyFormatter = formatDollars): string => {
  if (!Number.isInteger(cents)) {
    throw new Error('Dont use floats for currency');
  }

  if (cents === 0) {
    if (currencyFormatter === formatWithoutCurrency) {
      return '0.00';
    }
    return '$0.00';
  }
  const parsedCents = cents.toString();
  // check if cents has less than 3 letters, like '-99'
  const isDiscount = cents < 0 && parsedCents.length < 4;
  // We want to display a leading zero
  const dollarsString = isDiscount ? '-0' : parsedCents.slice(0, CENTS_START_INDEX) || '0';
  const centsString = cents.toString().slice(CENTS_START_INDEX);
  return currencyFormatter(dollarsString, centsString);
};

// percentage should be out of 100, e.g. 70 for 70%.
export const percentOfCurrency = (cents: ICurrency, percentage: number): ICurrency => {
  const resultParts = (cents * (percentage / ONE_HUNDRED)).toString().split('.');
  const integer = toNumber(resultParts[0]) || 0;
  return resultParts.length === 1 || (toNumber(resultParts[1][0]) || 0) < ROUND_UP_THRESHOLD
    ? integer
    : integer + 1; // Round up if the first decimal is 5 or greater
};
